const validateTitle = (title) => {
    if (title === undefined || title === null || title.trim() === "") {
      throw 'Please provide a title.';
    }
  };
  
  const validateSlug = (slug) => {
    if (slug === undefined || slug === null || slug.trim() === "") {
      throw 'Please provide a username.';
    }
  };

  const validateHighlightColor = (highlight_color) => {
    const hexColorRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
    if (highlight_color && !hexColorRegex.test(highlight_color)) {
      throw 'Please provide a valid hex color.';
    }
  };
  
  const handleValidation = (organization) => {
    const {title, slug, highlight_color} = organization;
    
    validateTitle(title);
    validateSlug(slug);
    validateHighlightColor(highlight_color);
  };
  
  export default handleValidation;